import React from "react";
import { useInView } from "react-intersection-observer";
import bgFooter from "../../images/Fondo-Footer.png";
import logo from "../../images/Logo-Empatica_Bco.png";
import empaticaRegular from "../../fonts/Branding-Semilight.otf";
import empaticaBold from "../../fonts/Branding-Bold.otf";
import { Link } from "react-router-dom";
import {
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaWhatsapp,
    FaTiktok,
    FaYoutube,
} from "react-icons/fa";

const Footer = () => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    const animatedText = (text, baseDelay = 0) =>
        text.split("").map((char, i) => (
            <span
                key={i}
                className={`inline-block opacity-0 ${inView ? "animate-fade-in" : ""}`}
                style={{ animationDelay: `${baseDelay + i * 0.03}s` }}
            >
                {char === " " ? "\u00A0" : char}
            </span>
        ));

    const linksInteres = [
        { text: "Producto Estrella", href: "#producto-estrella" },
        { text: "Conexión con API", href: "/ApiReference", external: true },
        { text: "Productos", href: "#productos" },
        { text: "POS Empatica", href: "https://quickpay.empatica.mx/#productos", external: true },
        { text: "Agendar Demo", href: "https://crm.empatica.mx/widget/booking/k9COyXU6LpKeNG5XA45J", external: true },
        { text: "Contáctanos", href: "https://crm.empatica.mx/widget/form/viX3JOLlon8EaKwfbqwm", external: true },
        { text: "Alta Sistec", href: "/privado/documentos/alta-sistec", external: true},
    ];

    const otrosLinks = [
        { text: "Menú inicial", to: "/empaticapage" },
        { text: "Sector Público", to: "/empaticapage/publico" },
        { text: "Consultoría", to: "/empaticapage/consultoria" },
        { text: "Quickpaymini", href: "https://quickpay.empatica.mx/", external: true },
        { text: "Aviso de privacidad cajeros", href: "/privado/documentos/aviso-privacidad-cajeros", external: true },
        { text: "Somos seguros", href: "/privado/documentos/somos-seguros", external: true },
        { text: "Garantías cajeros", href: "/privado/documentos/poliza-garantia", external: true },
    ];
    const redesSociales = [
        {
            icon: FaFacebookF,
            url: "https://www.facebook.com/empaticasolucionesmx",
            name: "Facebook"
        },
        {
            icon: FaInstagram,
            url: "https://www.instagram.com/empatica_soluciones/",
            name: "Instagram"
        },
        {
            icon: FaTiktok,
            url: "https://www.tiktok.com/@empatica_soluciones?_t=ZS-8wZra2ljbya&_r=1",
            name: "TikTok"
        },
        {
            icon: FaLinkedinIn,
            url: "https://www.linkedin.com/company/empatica-soluciones/",
            name: "LinkedIn"
        },
        {
            icon: FaWhatsapp,
            url: "https://api.whatsapp.com/send/?phone=524434799929&text=Hola+Equipo+de+Empatica%2C+v%C3%AD+tu+pagina+y+me+interesa+m%C3%A1s+informaci%C3%B3n+del+Quickpaymini&type=phone_number&app_absent=0",
            name: "WhatsApp"
        },
        {
            icon: FaYoutube,
            url: "https://www.youtube.com/@EmpaticaMX",
            name: "YouTube"
        }
    ];

    return (
        <footer
            ref={ref}
            className="text-white py-12 px-4 md:px-8 lg:px-16 font-[EmpaticaRegular]"
            style={{
                backgroundImage: `url(${bgFooter})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}>
            <div className="flex flex-col md:flex-row items-center justify-between gap-8">
                {/* Logo + Separador */}
                <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10 w-full md:w-auto md:ml-8 mx-auto">
                    <img
                        src={logo}
                        alt="Logo Empatica"
                        className="w-48 md:w-72 h-auto object-contain"
                    />
                    <div className="h-1 md:h-48 w-full md:w-1 bg-white rounded-md hidden md:block" />
                </div>

                {/* Links de interés */}
                <div className="flex flex-col lg:flex-row gap-6 md:gap-8 text-base items-center text-center lg:text-left lg:items-start">
                    <div className="flex flex-col gap-2">
                        <h3 className="text-3xl font-bold font-[EmpaticaBold]">{animatedText("Links de Interés", 0.1)}</h3>
                        {linksInteres.map(({ text, to, href, external }, i) => (
                            to ? (
                                <Link
                                    key={i}
                                    to={to}
                                    className="hover:underline"
                                >
                                    {animatedText(text, 0.3 + i * 0.1)}
                                </Link>
                            ) : (
                                <a
                                    key={i}
                                    href={href}
                                    target={external ? "_blank" : "_self"}
                                    rel={external ? "noopener noreferrer" : undefined}
                                    className="hover:underline"
                                >
                                    {animatedText(text, 0.3 + i * 0.1)}
                                </a>
                            )
                        ))}
                    </div>
                    <div className="flex flex-col gap-2 mt-8">
                        {otrosLinks.map(({ text, href, to, external }, i) => (
                            to ? (
                                <Link
                                    key={i}
                                    to={to}
                                    className="hover:underline"
                                >
                                    {animatedText(text, 0.3 + i * 0.1)}
                                </Link>
                            ) : (
                                <a
                                    key={i}
                                    href={href}
                                    className="hover:underline"
                                    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                >
                                    {animatedText(text, 0.3 + i * 0.1)}
                                </a>
                            )
                        ))}
                    </div>
                </div>

                {/* Redes sociales */}
                <div className="grid grid-cols-3 gap-4 text-5xl justify-items-center md:w-auto md:mr-24 mx-auto">
                    {redesSociales.map((red, index) => (
                        <a
                            key={index}
                            href={red.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Ir a ${red.name}`}
                            className="hover:scale-110 transition-transform duration-300"
                        >
                            <red.icon className="animate-float transition-transform duration-500 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12" />
                        </a>
                    ))}
                </div>
            </div>

            {/* Copyright */}
            <div className="mt-10 text-sm text-center font-semibold">
                {animatedText("© Empatica Soluciones, 2025", 2)}
            </div>

            {/* Keyframes y fuentes embebidas */}
            <style>
                {`
                    @font-face {
                        font-family: 'EmpaticaRegular';
                        src: url(${empaticaRegular}) format('opentype');
                        font-weight: normal;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: 'EmpaticaBold';
                        src: url(${empaticaBold}) format('opentype');
                        font-weight: bold;
                        font-style: normal;
                    }

                    @keyframes float {
                        0% { transform: translateY(0); }
                        50% { transform: translateY(-6px); }
                        100% { transform: translateY(0); }
                    }

                    @keyframes fadeInChar {
                        0% { opacity: 0; transform: translateY(10px); }
                        100% { opacity: 1; transform: translateY(0); }
                    }

                    .animate-float {
                        animation: float 3s ease-in-out infinite;
                    }

                    .animate-fade-in {
                        animation: fadeInChar 0.3s ease forwards;
                    }
                `}
            </style>
        </footer>
    );
};

export default Footer;
